import { cacheDom } from "../utils/QuerySelectors.js"

const dom = {}
const qs = {
  section: 'data-section-type="faq"',
}
const qsAll = {
  
}

export const setupFAQ = () => {
  cacheDom(dom, qs, qsAll)
  if(dom.section) {
    if(location.hash) {
      const hashElement = document.querySelector(location.hash)
      if(hashElement) {
        hashElement.closest('details').setAttribute('open', '')
        setTimeout(() => {
          window.scrollTo(0, hashElement.offsetTop - 120)
        }, 500)
      }
    }
  } 
}